// extracted by mini-css-extract-plugin
module.exports = {"round-icon":"a10a3f92e9--round-icon--2IFqx"};